<app-benefits>
    <mat-card>
        <mat-card-title class="header">
            <h4 appLocalizationPopupDirective localizationCode="BenefitGroup">{{ 'BenefitGroup' | translate: {Default: "Group"} }}</h4>

            <div class="buttons-container" *ngIf="form">
                <button mat-raised-button routerLink="{{routes.BENEFITS}}{{routes.GROUPS}}">{{ 'BenefitReturnToGroupsList' | translate: {Default: "Return To Groups List"} }}</button> 
                <button mat-raised-button setColor="primaryColour"  appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid">{{ 'Save' | translate: {Default: "Save"} }}</button> 
            </div>
        </mat-card-title>
        <ng-container *ngIf="form === undefined">
            <ngx-skeleton-loader
                count="5"
                [theme]="{ 
                    'height.px': 50
                }"
            ></ngx-skeleton-loader>
        </ng-container>
        <mat-card-content>
            
            <div class="group-details-form">

                <form class="form" *ngIf="form" [formGroup]="form">
                
                    <app-localization-text-form-field
                        [formElement]="{ formControl: 'name', localizationValueParam: 'text', text: ('BenefitGroupName' | translate: {Default: 'Name'}), disabled: 'false' }"
                        [parentGroup]="form"
                        [cultures]="cultures"
                        (emitAddtoFormArray)="addNewLocalization()"
                        (emitDeleteFromFormArray)="deleteLocalization($event.index)"
                    ></app-localization-text-form-field>
                
                    <div class="form-section">
                        <div class="form-section-title">
                            <h6></h6>
                        </div>
                        <div class="form-section-contents">
                            <div class="section-row">

                                <mat-form-field appearance="fill">
                                    <mat-label>
                                        {{ 'BenefitGroupDeductionFrequency' | translate: {Default: "Deduction Frequency"} }}
                                    </mat-label>
                            
                                    <mat-select disableOptionCentering formControlName="deductionFrequency">
                                        <ng-container *ngIf="deductionFrequencyOptions | async as deductionFrequencyOptions">
                                            <mat-option></mat-option>
                                            <mat-option 
                                                *ngFor="let option of deductionFrequencyOptions" 
                                                [value]="option.id">
                                                    {{option.name}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                
                </form>
            </div>

        
            <app-benefit-group-plans *ngIf="group !== undefined" [group]="group"></app-benefit-group-plans>
            
            
        </mat-card-content>
    </mat-card>

</app-benefits>
